import EnvHelper from './helpers/envHelper';

export const serverApiConfig = (server) => {
  const envHelper = EnvHelper.getInstance();
  let liveServer = window.electron?.store.get('trade.server') || server;
  let ser = '';

  if (liveServer) ser = liveServer;
  else ser = localStorage.getItem('trade.server') || window.electron?.store.get('trade.server');

  let metaServer = null;

  switch (ser) {
    case 'api':
      metaServer = envHelper.getGrpcUrl('live');
      break;
    case 'demo':
      metaServer = envHelper.getGrpcUrl('demo');
      break;
    default:
      return (metaServer = envHelper.getGrpcUrl(ser));
  }
  return metaServer;
};

export const getAccountTradeId = () => {
  let id = 0;
  const accId =
    localStorage.getItem('iuxmarkets.active.account') ||
    window.electron?.store.get('iuxmarkets.active.account');
  if (accId) {
    id = accId;
  }
  return parseInt(id);
};

export const actionsTypes = {
  0: {
    name: 'Buy',
    color: '#28AFFF'
  },
  1: {
    name: 'Sell',
    color: '#EF4533'
  },

  2: {
    name: 'Buy limit',
    color: '#28AFFF'
  },
  3: {
    name: 'Sell limit',
    color: '#EF4533'
  },
  4: {
    name: 'Buy stop',
    color: '#28AFFF'
  },
  5: {
    name: 'Sell stop',
    color: '#EF4533'
  },
  6: {
    name: 'Buy stop limit',
    color: '#28AFFF'
  },
  7: {
    name: 'Sell stop limit',
    color: '#EF4533'
  },
  8: {
    name: 'Close By',
    color: '#FE9F01'
  }
};

export const entrtyTypes = {
  0: {
    name: 'in',
    color: '#28AFFF'
  },
  1: {
    name: 'out',
    color: '#28AFFF'
  },
  2: {
    name: 'in/out',
    color: '#28AFFF'
  },
  3: {
    name: 'out by',
    color: '#28AFFF'
  }
};
